/* istanbul ignore file */

export const LITERS_PER_SQUARE_METER = 10;
export const LITERS_PER_GALLON = 3.78541;
